import clsx from "clsx";
import WTypography from "../wtypography/WTypography";
import parse from "html-react-parser";

/* eslint-disable-next-line */
export interface LSingleTitleSectionProps {
  id?: string;
  topTitle?: string;
  mainTitle?: string;
  subTitle?: string;
  center?: boolean;
  backgroundColor?: string;
  textColor?: string;
}

export function LSingleTitleSection(props: LSingleTitleSectionProps) {
  return (
    <div
      style={{
        backgroundColor: props?.backgroundColor,
        color: props?.textColor,
      }}
      className="bg-eklight scroll-mt-16"
      id={props?.id}
    >
      <div
        className={clsx([
          props?.center && "text-center",
          "container flex flex-col gap-2 px-4 pt-2 mx-auto lg:max-w-7xl",
        ])}
      >
        {props?.topTitle && (
          <WTypography
            textColor={props?.textColor}
            text={props?.topTitle}
            className="text-xl font-semibold"
          />
        )}
        {props?.mainTitle && (
          <WTypography
            textColor={props?.textColor}
            text={props?.mainTitle}
            className="text-4xl font-bold"
          />
        )}
        {props?.subTitle && (
          <WTypography
            textColor={props?.textColor}
            text={props?.subTitle}
            className="text-base lg:text-2xl"
          />
        )}
      </div>
    </div>
  );
}

export default LSingleTitleSection;
